import React from "react";
import Icon from "@mdi/react";
import { mdiCheck, mdiClose, mdiShieldAlertOutline } from "@mdi/js";
import styles from "./styles.module.scss";
import { clsx } from "@ismael1361/utils";

export interface ConfirmationMessageProps {
	toolName: string;
	description: string;
	status: "pending" | "approved" | "denied";
	onConfirm?: (approved: boolean) => void;
	disabled?: boolean;
}

export const ConfirmationMessage: React.FC<ConfirmationMessageProps> = ({ toolName, description, status, onConfirm, disabled }) => {
	const isPending = status === "pending";
	const isApproved = status === "approved";

	return (
		<div className={styles.confirmationInline}>
			<div className={styles.confirmationInlineHeader}>
				<Icon
					path={mdiShieldAlertOutline}
					size={0.65}
					className={styles.confirmationInlineIcon}
				/>
				<span className={styles.confirmationInlineToolName}>{toolName.replace(/_/g, " ")}</span>
			</div>
			<p className={styles.confirmationInlineTitle}>Confirmação necessária</p>
			<p className={styles.confirmationInlineDescription}>{description}</p>
			{isPending ? (
				<div className={styles.confirmationInlineActions}>
					<button
						className={clsx(styles.confirmationInlineBtn, styles.confirmInlineBtnDeny)}
						onClick={() => onConfirm?.(false)}
						disabled={disabled}
					>
						<Icon
							path={mdiClose}
							size={0.55}
						/>
						Negar
					</button>
					<button
						className={clsx(styles.confirmationInlineBtn, styles.confirmInlineBtnApprove)}
						onClick={() => onConfirm?.(true)}
						disabled={disabled}
					>
						<Icon
							path={mdiCheck}
							size={0.55}
						/>
						Aprovar
					</button>
				</div>
			) : (
				<div className={clsx(styles.confirmationInlineBadge, isApproved ? styles.confirmBadgeApproved : styles.confirmBadgeDenied)}>
					<Icon
						path={isApproved ? mdiCheck : mdiClose}
						size={0.5}
					/>
					{isApproved ? "Aprovado" : "Negado"}
				</div>
			)}
		</div>
	);
};
